import { Injectable, OnDestroy } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { Observable, Subscription } from "rxjs";
import { filter, map, withLatestFrom } from "rxjs/operators";
import { CustomStoreEntities } from "../models/store-finder.model";
import { CustomFindStores } from "../store/actions/custom-store-finder.actions";
import { getFindStoresEntities, getStoresLoading, getStoresSuccess } from "../store/selectors/custom-store-finder.selectors";
import { CustomStateWithStoreFinder } from "../store/selectors/custom-store-finder.states";

@Injectable({
  providedIn: 'root',
})
export class CustomStoreFinderService implements OnDestroy {
  protected subscriptions: Subscription = new Subscription();

  ngOnDestroy() {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  constructor(
    protected store: Store<CustomStateWithStoreFinder>
  ) {
    this.reloadStoreEntitiesOnContextChange();
  }

  protected reloadStoreEntitiesOnContextChange(): void {
    this.subscriptions.add(this.getFindStoresEntities()
      .pipe(
        filter((data) => this.isEmpty(data)),
        withLatestFrom(
          this.getStoresLoading(),
          this.getStoresLoaded()
        )
      )
      .subscribe(([, loading, loaded]) => {
        if (!loading && !loaded) {
          this.callFindStoresAction();
        }
      }));
  }

  callFindStoresAction(): void {
    this.findStoresAction();
  }

  findStoresAction() {
    this.store.dispatch(new CustomFindStores({}));
  }

  getStoresLoading(): Observable<boolean> {
    return this.store.pipe(select(getStoresLoading));
  }

  getStoresLoaded(): Observable<boolean> {
    return this.store.pipe(select(getStoresSuccess));
  }

  getFindStoresEntities(): Observable<CustomStoreEntities> {
    return this.store.pipe(
      select(getFindStoresEntities),
      map((data) => data.findStoresEntities)
    );
  }

  private isEmpty(store: CustomStoreEntities): boolean {
    return (
      !store || (typeof store === 'object' && Object.keys(store).length === 0)
    );
  }
}
